
const digest = '6d77e67ff576cb1b512e92031afb8368d8c13cd748e7f00890c23be91a284c21';
const classes = {"wrapper":"_wrapper_u5mtu_1","title":"_title_u5mtu_8","subtitle":"_subtitle_u5mtu_12"};
const css = `._wrapper_u5mtu_1 {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  cursor: pointer;
}
._wrapper_u5mtu_1 ._title_u5mtu_8 {
  font-weight: 500;
  color: #000000;
}
._wrapper_u5mtu_1 ._subtitle_u5mtu_12 {
  color: #97a4ba;
}
._wrapper_u5mtu_1:hover {
  background-color: #d9e8fe;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  